import * as React from "react";
import LocalSelectField from "../Base/Fields/LocalSelectField";
import Modal from "../Base/Modals/Modal";

export default function InvoiceSendForm({
  closeFunction,
  sendInvoice,
  value,
  setValue,
}) {
  return (
    <Modal
      closeFunction={closeFunction}
      title="Skicka faktura"
      onAccept={sendInvoice}
      acceptTitle="Skicka faktura"
      denyTitle="Avbryt"
    >
      <LocalSelectField
        id="_send_invoice_method"
        value={value}
        choices={[
          { v: "Email", d: "Email" },
          { v: "Kivra", d: "Kivra" },
          {
            v: "EInvoice",
            d: "E-faktura",
          },
          { v: "Mail", d: "Post" },
        ]}
        onChange={(val) => setValue(val)}
        title="Leveransmetod"
      />
    </Modal>
  );
}
